var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconMessage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: "90mm",
    height: "80mm",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    viewBox: "0 0 9000 8000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_x0020_1"
  }, /*#__PURE__*/React.createElement("metadata", {
    id: "CorelCorpID_0Corel-Layer"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8277 157l-7795 0 -212 0 0 213 0 5461 0 1738 0 411 335 -239 2355 -1682 22 -16 26 0 5269 0 212 0 0 -212 0 -211 -1366 0 -84 0 0 -1 -4124 0 -67 0 -56 39 -1965 1404 -133 95 0 -163 0 -1163 0 -5165 0 -84 84 0 7203 0 84 0 0 84 0 4086 424 0 0 -4382 0 -213 -212 0zm-6187 3858l3686 -1 0 -468 -3686 0 0 469zm0 -1363l4902 0 0 -469 -4902 1 0 468z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMessage);
export default __webpack_public_path__ + "static/media/icon-message.b4ec71ea5da9b71b39f2197cbec7cc3e.svg";
export { ForwardRef as ReactComponent };